import { RootState } from '@reducers';

export const selectSearchCorporateMember = (state: RootState) =>
  state.userDashboardRouteReducer.searchCorporateMemberReducer;
